import { get } from './httpClient'

export const getEnumOrderStatus = () => get('/enum/order-payment-status')
export const getEnumShipStatus = () => get('/enum/order-ship-status')
export const getEnumPayment = () => get('/enum/payment')
